const themeStyles = colors => {
  const styles = {
    containerOut: {
      position: 'relative',
      height: '280px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      borderRadius: 4,
      boxShadow: 'rgba(0, 0, 0, 0.06) 0px 3px 7px 0px'
    },
    topContainer: {
      flex: 1,
      height: 230,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 21,
      paddingBottom: 15,
      backgroundColor: colors.white
    },
    bottomContainer: {
      height: '36.5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: `1px solid ${colors.placebo}`,
      backgroundColor: colors.white
    },
    title: {
      color: colors.approxBlack,
      fontSize: 16,
      fontWeight: 700,
      letterSpacing: 0.23,
      lineHeight: '24px',
      textAlign: 'center',
      marginBottom: 21
    },
    carousel: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flex: 1,
      maxHeight: 'calc(100% - 40px)'
    },
    slider: {
      flex: 1
    },
    link: {
      color: colors.primary,
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '17px',
      textAlign: 'center',
      cursor: 'pointer'
    },
    noDataContainer: {
      height: '130px',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.white
    },
    noDataText: {
      paddingTop: 4,
      fontSize: 16,
      letterSpacing: 0,
      lineHeight: '18.4px',
      textAlign: 'center',
      color: colors.secondaryGray
    },
    emptyIcon: {
      color: colors.primary
    },
    errorContainer: {
      height: '100%',
      width: '100%',
      display: 'flex',
      fontSize: 16,
      fontWeight: 700,
      lineHeight: '18.4px',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      color: colors.approxBlack,
      backgroundColor: colors.white
    },
    errorText: {
      margin: '0 10px',
      textAlign: 'center'
    }
  }

  styles.noDataTopContainer = { ...styles.topContainer, height: '213px' }
  return styles
}

export default themeStyles
